import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import SEO from '../../components/SEO';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import { Phone } from 'lucide-react';

const ForceUrbaniaCity = () => {
  const { cityName } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [cityName]);

  const cityRoutes = {
    amritsar: [
      { destination: 'Agra', fare: 61200, slug: 'amritsar-to-agra' },
      { destination: 'Amarnath', fare: 54000, slug: 'amritsar-to-amarnath' },
      { destination: 'Ayodhya', fare: 108000, slug: 'amritsar-to-ayodhya' },
      { destination: 'Badrinath Kedarnath', fare: 111600, slug: 'amritsar-to-badrinath-kedarnath' },
      { destination: 'Char Dham', fare: 111600, slug: 'amritsar-to-char-dham' },
      { destination: 'Dalhousie', fare: 32400, slug: 'amritsar-to-dalhousie' },
      { destination: 'Dharamshala', fare: 39600, slug: 'amritsar-to-dharamshala' },
      { destination: 'Govind Ghat', fare: 108000, slug: 'amritsar-to-govind-ghat' },
      { destination: 'Haridwar', fare: 46800, slug: 'amritsar-to-haridwar' },
      { destination: 'Jaipur', fare: 61200, slug: 'amritsar-to-jaipur' },
      { destination: 'Jim Corbett', fare: 61200, slug: 'amritsar-to-jim-corbett' },
      { destination: 'Kasauli', fare: 46800, slug: 'amritsar-to-kasauli' }
    ],
    chandigarh: [
      { destination: 'Manali', fare: 32400, slug: 'chandigarh-to-manali' },
      { destination: 'Shimla', fare: 12960, slug: 'chandigarh-to-shimla' },
      { destination: 'Dharamshala', fare: 43200, slug: 'chandigarh-to-dharamshala' },
      { destination: 'Amritsar', fare: 18720, slug: 'chandigarh-to-amritsar' },
      { destination: 'Dalhousie', fare: 43200, slug: 'chandigarh-to-dalhousie' },
      { destination: 'Mussoorie', fare: 28800, slug: 'chandigarh-to-mussoorie' },
      { destination: 'Himachal Pradesh', fare: 21600, slug: 'chandigarh-to-himachal-pradesh' },
      { destination: 'Khatu Shyam', fare: 43200, slug: 'chandigarh-to-khatu-shyam' },
      { destination: 'Salasar Balaji', fare: 43200, slug: 'chandigarh-to-salasar-balaji' },
      { destination: 'Kasol', fare: 43200, slug: 'chandigarh-to-kasol' },
      { destination: 'Delhi Airport', fare: 18720, slug: 'chandigarh-to-delhi-airport' },
      { destination: 'Delhi', fare: 18000, slug: 'chandigarh-to-delhi' }
    ],
    delhi: [
      { destination: 'Manali', fare: 54000, slug: 'delhi-to-manali' },
      { destination: 'Shimla', fare: 46800, slug: 'delhi-to-shimla' },
      { destination: 'Dharamshala', fare: 57600, slug: 'delhi-to-dharamshala' },
      { destination: 'Amritsar', fare: 36000, slug: 'delhi-to-amritsar' },
      { destination: 'Dalhousie', fare: 57600, slug: 'delhi-to-dalhousie' },
      { destination: 'Mussoorie', fare: 36000, slug: 'delhi-to-mussoorie' },
      { destination: 'Himachal Pradesh', fare: 43200, slug: 'delhi-to-himachal-pradesh' },
      { destination: 'Khatu Shyam', fare: 25200, slug: 'delhi-to-khatu-shyam' },
      { destination: 'Salasar Balaji', fare: 25200, slug: 'delhi-to-salasar-balaji' },
      { destination: 'Kasol', fare: 54000, slug: 'delhi-to-kasol' },
      { destination: 'Mathura', fare: 18000, slug: 'delhi-to-mathura' },
      { destination: 'Vrindavan', fare: 16560, slug: 'delhi-to-vrindavan' }
    ],
    mohali: [
      { destination: 'Manali', fare: 32400, slug: 'mohali-to-manali' },
      { destination: 'Shimla', fare: 12960, slug: 'mohali-to-shimla' },
      { destination: 'Dharamshala', fare: 43200, slug: 'mohali-to-dharamshala' },
      { destination: 'Amritsar', fare: 18000, slug: 'mohali-to-amritsar' },
      { destination: 'Dalhousie', fare: 43200, slug: 'mohali-to-dalhousie' },
      { destination: 'Mussoorie', fare: 28800, slug: 'mohali-to-mussoorie' },
      { destination: 'Himachal Pradesh', fare: 25200, slug: 'mohali-to-himachal-pradesh' },
      { destination: 'Khatu Shyam', fare: 43200, slug: 'mohali-to-khatu-shyam' },
      { destination: 'Salasar Balaji', fare: 43200, slug: 'mohali-to-salasar-balaji' },
      { destination: 'Kasol', fare: 43200, slug: 'mohali-to-kasol' },
      { destination: 'Delhi Airport', fare: 18000, slug: 'mohali-to-delhi-airport' },
      { destination: 'Delhi', fare: 17280, slug: 'mohali-to-delhi' }
    ],
    patiala: [
      { destination: 'Agra', fare: 39600, slug: 'patiala-to-agra' },
      { destination: 'Amarnath', fare: 57600, slug: 'patiala-to-amarnath' },
      { destination: 'Amritsar', fare: 18000, slug: 'patiala-to-amritsar' },
      { destination: 'Amritsar Sahib', fare: 18000, slug: 'patiala-to-amritsar-sahib' },
      { destination: 'Ayodhya', fare: 86400, slug: 'patiala-to-ayodhya' },
      { destination: 'Badrinath Kedarnath', fare: 90000, slug: 'patiala-to-badrinath-kedarnath' },
      { destination: 'Char Dham', fare: 90000, slug: 'patiala-to-char-dham' },
      { destination: 'Dalhousie', fare: 43200, slug: 'patiala-to-dalhousie' },
      { destination: 'Dharamshala', fare: 43200, slug: 'patiala-to-dharamshala' },
      { destination: 'Golden Temple Amritsar', fare: 18000, slug: 'patiala-to-golden-temple-amritsar' },
      { destination: 'Govind Ghat', fare: 86400, slug: 'patiala-to-govind-ghat' },
      { destination: 'Haridwar', fare: 25200, slug: 'patiala-to-haridwar' }
    ]
  };

  const routes = cityRoutes?.[cityName?.toLowerCase()] || cityRoutes?.amritsar;
  const formattedCityName = cityName?.charAt(0)?.toUpperCase() + cityName?.slice(1)?.toLowerCase();

  const handleViewCabs = (route) => {
    // Navigate to booking page with proper route slug
    navigate(`/force-urbania-route-booking/${route?.slug}`);
  };

  return (
    <>
      <SEO
        title={`Force Urbania From ${formattedCityName} - Advait Tour and Travels`}
        description={`Book spacious and reliable Force Urbania from ${formattedCityName}. Perfect for group travel with 12 and 16 seater options.`}
        keywords={`force urbania from ${cityName}, ${cityName} force urbania, ${cityName} group travel`}
        canonicalUrl={`${window.location?.origin}/force-urbania/${cityName}`}
        ogTitle={`Force Urbania From ${formattedCityName} - Advait Tour and Travels`}
        ogDescription={`Book spacious and reliable Force Urbania from ${formattedCityName}. Perfect for group travel with 12 and 16 seater options.`}
        ogUrl={`${window.location?.origin}/force-urbania/${cityName}`}
        structuredData={{
          "@context": "https://schema.org",
          "@type": "TravelAgency",
          "name": "Advait Tour and Travels",
          "description": `Force Urbania from ${formattedCityName}`
        }}
      />
      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="py-20">
          {/* Hero Section */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 py-16 mb-12">
            <div className="container mx-auto px-4">
              <h1 className="text-4xl md:text-5xl font-bold text-white text-center">
                Force Urbania From {formattedCityName}
              </h1>
            </div>
          </div>

          {/* Route Cards */}
          <div className="container mx-auto px-4 mb-16">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
              {routes?.map((route, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 p-6 hover-lift animate-fade-in-up cursor-pointer"
                  style={{ animationDelay: `${index * 0.1}s` }}
                  onClick={() => handleViewCabs(route)}
                >
                  <h3 className="text-xl font-bold text-gray-800 mb-3 text-center">
                    {formattedCityName} To {route?.destination}
                  </h3>
                  <p className="text-gray-600 text-center mb-4">
                    Fare Start - ₹{route?.fare?.toLocaleString('en-IN')}/-
                  </p>
                  <button
                    className="w-full py-3 bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold rounded-lg transition-all duration-300 btn-hover transform hover:scale-105"
                  >
                    VIEW CABS
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Visitor's Guide */}
          <div className="container mx-auto px-4 mb-16">
            <div className="max-w-5xl mx-auto bg-white rounded-xl shadow-lg p-8">
              <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
                Visitor's Guide
              </h2>
              
              <div className="prose max-w-none space-y-6 text-gray-700">
                <h3 className="text-2xl font-bold text-gray-800">
                  Book Spacious and Reliable Force Urbania in {formattedCityName}
                </h3>
                <p>
                  Looking for a vehicle for your next group trip? Whether for a family outing, corporate event, wedding, or tourist trip, at Advait Tour and Travels we have Force Urbania in {formattedCityName} – a vehicle that gives you comfort and convenience. With lots of space, modern safety features, and smooth ride it's the perfect solution for group travel.
                </p>
                <p>
                  Our fleet has everything you need to make your journey comfortable, safe and enjoyable from start to end. Find out why so many people trust us when they hire Force Urbania in {formattedCityName} for their travel needs.
                </p>

                <h3 className="text-2xl font-bold text-gray-800 mt-8">
                  Why Force Urbania in {formattedCityName}:
                </h3>
                <p>
                  When you hire Force Urbania in {formattedCityName} you get a vehicle designed for long distance comfort, perfect for big groups. Lots of space, robust safety features and reliability is what travellers in {formattedCityName} love.
                </p>
                <p>
                  Whether it is a family trip, a corporate trip, or a special occasion, Force Urbania in {formattedCityName} will give you a hassle-free and comfortable ride.
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Spacious Interior:</strong> 12 and 16 seater Force Urbania has enough space for everyone to travel comfortably. Even on long drives everyone will have enough leg space.</li>
                  <li><strong>Safety First:</strong> We value your safety above everything. Force Urbania has modern safety features like ABS, airbags and more. Travel with us and you are in good hands.</li>
                  <li><strong>Perfect for Any Occasion:</strong> Whether you need transport for a corporate event, family trip, or wedding, hiring Force Urbania in {formattedCityName} will give you a smooth ride, no matter the occasion.</li>
                </ul>

                <h3 className="text-2xl font-bold text-gray-800 mt-8">
                  Features of Force Urbania:
                </h3>
                <p>What makes Force Urbania in {formattedCityName} special? Here's a look:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Seating Capacity:</strong> With a seating capacity of 12 and 16, Force Urbania is perfect for group travel. Whether you're with friends, family, or colleagues everyone will have space and comfort.</li>
                  <li><strong>Full Air-conditioning:</strong> Regardless of the season, the full AC interior will keep everyone cool and comfortable during the journey, even on hot summer days in {formattedCityName}.</li>
                  <li><strong>Smooth Ride:</strong> With advanced suspension Force Urbania gives a smooth ride even on rough roads. Whether you are driving through city roads or offbeat destinations you can be sure the journey will be comfortable.</li>
                  <li><strong>Safety Features:</strong> With ABS and airbags Force Urbania keeps all passengers safe during the journey. We care about your safety.</li>
                  <li><strong>Space for Luggage:</strong> Our 12 and 16 seater Force Urbania has space for luggage and equipment. Hence it is perfect for your long trips or events where you need to carry extra items.</li>
                </ul>

                <h3 className="text-2xl font-bold text-gray-800 mt-8">
                  Who Can Hire Force Urbania?
                </h3>
                <p>
                  Force Urbania in {formattedCityName} is perfect for all kinds of travellers. From family trips to corporate events and tourist excursions it can accommodate all:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Corporate Groups:</strong> Need a vehicle for your team's next corporate outing, meeting or conference? Force Urbania in {formattedCityName} is a professional and comfortable way to move your team to and from events.</li>
                  <li><strong>Family Trips:</strong> Are you planning a road trip with your family? Force Urbania has enough space for everyone to travel comfortably with space for luggage and other belongings. The comfortable seating, air conditioning and smooth ride makes it perfect for long drives.</li>
                  <li><strong>Weddings and Special Events:</strong> Planning a wedding or special event? Transport your guests in style with Force Urbania in {formattedCityName}. It's perfect for shuttling guests to and from venues so everyone reaches safely and on time.</li>
                  <li><strong>Tourist Groups:</strong> If you are planning a sightseeing trip or adventure trip in or around {formattedCityName}, Force Urbania is for your group.</li>
                </ul>

                <h3 className="text-2xl font-bold text-gray-800 mt-8">
                  Hassle-Free Booking for Force Urbania in {formattedCityName}:
                </h3>
                <p>
                  At Advait Tour and Travels we make it easy to book Force Urbania in {formattedCityName} for any of your occasion. Whether you need it for a day or for a longer vacation, our booking process is super easy. Here's how:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Simple and Quick Booking Process:</strong> Fill up the form on our website or call us to book. Our customer service team is always available to help you with any query.</li>
                  <li><strong>Transparent Pricing:</strong> We offer the best rates for hiring Force Urbania in {formattedCityName} with no hidden charges. Our pricing is transparent so you know what to expect.</li>
                  <li><strong>Flexible Rental Options:</strong> Whether you need it for a few hours, full day or more we have flexible rental options to fit your schedule.</li>
                  <li><strong>24/7 Customer Support:</strong> Our support team is available 24/7 to help you with any changes, queries, or concerns about your booking.</li>
                </ul>

                <h3 className="text-2xl font-bold text-gray-800 mt-8">
                  Why Book Force Urbania in {formattedCityName} with Advait Tour and Travels?
                </h3>
                <p>
                  At Advait Tour and Travels we offer top-class service and well-maintained vehicles. Here's why you should book with us when you book Force Urbania in {formattedCityName}:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Well-Maintained Vehicles:</strong> We ensure all our vehicles including Force Urbania are serviced and maintained regularly to give you the best performance. You will have a smooth, safe & comfortable ride.</li>
                  <li><strong>Experienced and Professional Drivers:</strong> Our drivers are experienced and trained to drive on city roads and rural roads with ease. They are professional, punctual and courteous so you and your group have a good time.</li>
                  <li><strong>Customer First:</strong> We put our customers first. From the time you book till the end of your journey we will make sure your experience with Advait Tour and Travels is above your expectations.</li>
                </ul>

                <p className="mt-8">
                  Ready to book Force Urbania in {formattedCityName} and experience luxury and comfort? Whether you are planning a family trip, corporate trip or an event Advait Tour and Travels is here to offer you a comfortable ride. Call us now to book Force Urbania in {formattedCityName} and travel stress free. Your journey is in safe hands!
                </p>

                <h3 className="text-2xl font-bold text-gray-800 mt-8">
                  FAQs
                </h3>
                <ol className="list-decimal pl-6 space-y-2">
                  <li>How many passengers can sit in Force Urbania?</li>
                  <li>Can I book the Force Urbania for short trips?</li>
                  <li>Can I use the Force Urbania for long distance travel?</li>
                  <li>Does the Force Urbania have an air condition facility?</li>
                  <li>What amenities are included with the Force Urbania?</li>
                  <li>How can I book the Force Urbania services with a driver?</li>
                  <li>Is driver facility included in Force Urbania rental service?</li>
                  <li>What is the cancellation policy for Force Urbania rental?</li>
                  <li>Are there mileage limits on the rentals?</li>
                  <li>How often are the Force Urbania vehicles serviced?</li>
                  <li>Can I rent the Force Urbania for corporate events?</li>
                </ol>
              </div>
            </div>
          </div>

          {/* Contact Section */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 py-12">
            <div className="container mx-auto px-4 text-center">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                We're here for you 24/7!
              </h2>
              <p className="text-xl text-white mb-6">
                Give us a call anytime
              </p>
              <a
                href="tel:+917998666660"
                className="inline-flex items-center gap-3 px-8 py-4 bg-white text-blue-600 font-bold text-2xl rounded-full hover:bg-gray-100 transition-colors duration-300"
              >
                <Phone className="w-6 h-6" />
                +91-79986-66660
              </a>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default ForceUrbaniaCity;